import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbComponent, IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { TemplateSettingsComponent } from '../template-settings/template-settings.component';

@Component({
  imports: [BreadcrumbComponent, TranslateModule, TemplateSettingsComponent],
  selector: 'app-global-templates',
  templateUrl: './global-templates.component.html',
})
export class GlobalTemplatesComponent {
  private readonly translate = inject(TranslateService);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.settings.accountPanel'),
      link: '/dashboard',
    },
    {
      label: this.translate.instant('pages.settings.templateSettings.title'),
    },
  ];
}
